import { createRouter, createWebHistory } from 'vue-router'
import Home from './views/Home.vue'
import Estimate from './views/Estimate.vue'
import EstimateDetail from './views/EstimateDetailAfter.vue'
import Car from './views/Car.vue'
import InspectionSettlement from './views/InspectionSettlement.vue'
import InspectionSettlementComplete from './views/InspectionSettlementComplete.vue'
import CarCareTop from './views/CarCareTop.vue'
import PreferredDate from './views/PreferredDate.vue'
import Payment from './views/Payment.vue'
import InspectionThanks from './views/InspectionThanks.vue'
import InspectionDetail from './views/InspectionDetail.vue'
// v2
import EstimateV2 from './views/v2/Estimate.vue'
import EstimateDetailV2 from './views/v2/EstimateDetailAfter.vue'
import CarV2 from './views/v2/Car.vue'
import InspectionSettlementV2 from './views/v2/InspectionSettlement.vue'
import InspectionSettlementCompleteV2 from './views/v2/InspectionSettlementComplete.vue'
import CarCareTopV2 from './views/v2/CarCareTop.vue'
import PreferredDateV2 from './views/v2/PreferredDate.vue'
import PaymentV2 from './views/v2/Payment.vue'
import InspectionThanksV2 from './views/v2/InspectionThanks.vue'
import InspectionDetailV2 from './views/v2/InspectionDetail.vue'
import LeaseTopV2 from './views/v2/LeaseTop.vue'
import InspectionTopV2 from './views/v2/InspectionTop.vue'
import CardSpecV2 from './views/v2/CardSpec.vue'
import CardSpecHouseV2 from './views/v2/CardSpecHouse.vue'
import OptionCarQRV2 from './views/v2/OptionCarQR.vue'
import RedirectCarV2 from './views/v2/RedirectCar.vue'
import RedirectPreferredDateV2 from './views/v2/RedirectPreferredDate.vue'
import AccountDeleteConfirmV2 from './views/v2/AccountDeleteConfirm.vue'
import AccountDeleteCompleteV2 from './views/v2/AccountDeleteComplete.vue'
import MaintenancePackTopV2 from './views/v2/MaintenancePack/Top.vue'
import CarInspectionConfirmV2 from './views/v2/MaintenancePack/CarInspectionConfirm.vue'
import MaintenancePackApplyV2 from './views/v2/MaintenancePack/Apply.vue'
import MaintenancePackTermsOfServiceV2 from './views/v2/MaintenancePack/TermsOfService.vue'
import MaintenancePackApplyCompleteV2 from './views/v2/MaintenancePack/ApplyComplete.vue'
import AppTopV2 from './views/v2/AppTop.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  // v1
  {
    // 見積もり掲示画面・詳細画面（予約前）
    path: '/estimate',
    name: 'Estimate',
    component: Estimate
  },
  {
    // 見積り詳細画面（予約後）
    path: '/estimatedetail',
    name: 'EstimateDetail',
    component: EstimateDetail
  },
  {
    // 車検情報入力画面
    path: '/car',
    name: 'Car',
    component: Car
  },
  {
    // クレジット選択画面
    path: '/inspectionSettlement',
    name: 'InspectionSettlement',
    component: InspectionSettlement
  },
  {
    // 決済完了画面
    path: '/inspectionSettlementComplete',
    name: 'InspectionSettlementComplete',
    component: InspectionSettlementComplete
  },
  {
    // カーケアTOP画面
    path: '/carcaretop',
    name: 'CarCareTop',
    component: CarCareTop
  },
  {
    // 希望日選択画面
    path: '/preferreddate',
    name: 'PreferredDate',
    component: PreferredDate
  },
  {
    // GMO表示用画面
    path: '/payment',
    name: 'Payment',
    component: Payment
  },
  {
    path: '/inspectionThanks',
    name: 'InspectionThanks',
    component: InspectionThanks
  },
  {
    // 車検詳細画面
    path: '/inspectiondetail',
    name: 'InspectionDetail',
    component: InspectionDetail
  },
  // v2
  {
    // 見積もり掲示画面・詳細画面（予約前）
    path: '/v2/estimate',
    name: 'EstimateV2',
    component: EstimateV2
  },
  {
    // 見積り詳細画面（予約後）
    path: '/v2/estimatedetail',
    name: 'EstimateDetailV2',
    component: EstimateDetailV2
  },
  {
    // 車検情報入力画面
    path: '/v2/car',
    name: 'CarV2',
    component: CarV2
  },
  {
    // クレジット選択画面
    path: '/v2/inspectionSettlement',
    name: 'InspectionSettlementV2',
    component: InspectionSettlementV2
  },
  {
    // 決済完了画面
    path: '/v2/inspectionSettlementComplete',
    name: 'InspectionSettlementCompleteV2',
    component: InspectionSettlementCompleteV2
  },
  {
    // カーケアTOP画面
    path: '/v2/carcaretop',
    name: 'CarCareTopV2',
    component: CarCareTopV2
  },
  {
    // 車検TOP画面
    path: '/v2/inspectiontop',
    name: 'InspectionTopV2',
    component: InspectionTopV2
  },
  {
    // 希望日選択画面
    path: '/v2/preferreddate',
    name: 'PreferredDateV2',
    component: PreferredDateV2
  },
  {
    // GMO表示用画面
    path: '/v2/payment',
    name: 'PaymentV2',
    component: PaymentV2
  },
  {
    path: '/v2/inspectionThanks',
    name: 'InspectionThanksV2',
    component: InspectionThanksV2
  },
  {
    // 車検詳細画面
    path: '/v2/inspectiondetail',
    name: 'InspectionDetailV2',
    component: InspectionDetailV2
  },
  {
    // リースTOP画面
    path: '/v2/leasetop',
    name: 'LeaseTopV2',
    component: LeaseTopV2
  },
  {
    // カードスペック画面
    path: '/v2/cardspec',
    name: 'CardSpecV2',
    component: CardSpecV2
  },
  {
    // カードスペック(ハウスカード)画面
    path: '/v2/cardspecHouse',
    name: 'CardSpecHouseV2',
    component: CardSpecHouseV2
  },
  {
    // 車検証情報登録画面
    path: '/v2/optionCarQR',
    name: 'OptionCarQRV2',
    component: OptionCarQRV2
  },
  {
    // リダイレクト用車検情報入力画面
    path: '/v2/redirectcar',
    name: 'RedirectCarV2',
    component: RedirectCarV2
  },
  {
    // リダイレクト用希望日選択画面
    path: '/v2/redirectpreferreddate',
    name: 'RedirectPreferredDateV2',
    component: RedirectPreferredDateV2
  },
  {
    // アカウント削除 削除内容確認画面
    path: '/v2/accountDelete/confirm',
    name: 'AccountDeleteConfirmV2',
    component: AccountDeleteConfirmV2
  },
  {
    // アカウント削除 削除完了画面
    path: '/v2/accountDelete/complete',
    name: 'AccountDeleteCompleteV2',
    component: AccountDeleteCompleteV2
  },
  {
    // メンテナンスパックTop画面
    path: '/v2/MaintenancePack/top',
    name: 'MaintenancePackTopV2',
    component: MaintenancePackTopV2
  },
  {
    // メンテナンスパック車検証情報確認画面
    path: '/v2/MaintenancePack/CarInspectionConfirm',
    name: 'CarInspectionConfirmV2',
    component: CarInspectionConfirmV2
  },
  {
    // メンテナンスパック申込画面
    path: '/v2/MaintenancePack/apply',
    name: 'MaintenancePackApplyV2',
    component: MaintenancePackApplyV2
  },
  {
    // メンテナンスパック利用規約画面
    path: '/v2/MaintenancePack/termsOfService',
    name: 'MaintenancePackTermsOfServiceV2',
    component: MaintenancePackTermsOfServiceV2
  },
  {
    // メンテナンスパック仮申し込み完了画面
    path: '/v2/MaintenancePack/applyComplete',
    name: 'MaintenancePackApplyCompleteV2',
    component: MaintenancePackApplyCompleteV2
  },
  {
    // アプリTOPリダイレクト画面
    path: '/v2/moveAppTop',
    name: 'AppTopV2',
    component: AppTopV2
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
